import { SAVE } from 'constants/actions';
import { t } from 'utils/i18n';

// eslint-disable-next-line
export const actions = [{ id: SAVE, title: t(SAVE), show: 'always' }];
